function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnMais(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 9v6a1 1 0 0 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 2 0v6h6a1 1 0 0 1 0 2H9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    },
    className: "fills"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMais);
export default __webpack_public_path__ + "static/media/btn-mais.2987adf756703083e1445e947265fecc.svg";
export { ForwardRef as ReactComponent };